import { color, shadows, space } from "./designTokens";

export const dialogPaperSx = {
  backgroundColor: color.white,
  boxShadow: shadows.dialog,
  overflowX: "hidden",
} as const;

export const dialogTitleSx = {
  px: `${space.xxl}px`,
  py: `${space.xl}px`,
  backgroundColor: color.background,
} as const;

export const dialogContentSx = {
  px: `${space.xxl}px`,
  py: `${space.xl}px`,
  backgroundColor: color.white,
} as const;

export const dialogActionsSx = {
  px: `${space.xxl}px`,
  pb: `${space.xl}px`,
} as const;
